import _ from "lodash";

const NamespaceEvents = function NamespaceEvents(eventString, namespace) {
    return _.reduce(
        eventString.split(" "),
        function (prependString, currentString) {
            return [prependString, [currentString, namespace].join(".")].join(" ");
        },
        ""
    );
};
export default NamespaceEvents;
